import React, { useEffect, useState } from "react";

// Chakra imports
import { Flex } from "@chakra-ui/react";

// Custom components
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetOrganizationLogo } from "redux/organizationSlice";

export function SidebarBrand() {
  const dispatch = useDispatch();
  //   Chakra color mode
  const [logoUrl,setLogoUrl] = useState("")
  const logoData = useSelector((state) => state.logoData);

  const getOrganizationLogo = ()=>{
    dispatch(fetchAsyncGetOrganizationLogo())
      .then((res) => {})
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }
  useEffect(() => {
    getOrganizationLogo()
  }, []);

  useEffect(()=>{
    if(logoData && logoData?.downloadUrl){
      const url = logoData?.downloadUrl;
      setLogoUrl(url)
    }
  },[logoData])

  return (
    <Flex align="center" direction="column" className="logo-container">
      <img src={logoUrl ? logoUrl :""} alt="logo" style={{ width: "120px" ,height:'auto' }} />
    </Flex>
  );
}

export default SidebarBrand;
